import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { ColumnDef } from '@tanstack/react-table';

import BaseList from '@/components/base-list';
import useLayout from '@/hooks/useLayout';
import { type IContact } from '@/modules/contact/model/contact';
import { convertNumberToCurrency } from '@/utility/helper/common';
import { isValidDateString } from '@/utility/helper/dateUtils';
import dayjs from 'dayjs';

const Invoice = () => {
  useLayout({ title: 'Daftar Invoice' });

  const columns: ColumnDef<IContact>[] = useMemo(() => [
    {
      id: '1',
      accessorKey: 'invoice_date_time_utc',
      header: 'Tanggal Invoice',
      cell: ({ getValue }: any) => (
        isValidDateString(getValue()) ? dayjs(getValue()).format('DD MMMM YYYY') : '-'
      ),
    },
    {
      id: '2',
      accessorKey: 'invoice_number',
      header: 'No Invoice',
      cell: ({ getValue, row }: any) => (
        <Link to={`/invoices/show/${row.original.invoice_id}`} className="text-blue-500">
          {getValue()}
        </Link>
      ),
    },
    {
      id: '3',
      accessorKey: 'invoice_due_date_time_utc',
      header: 'Tanggal Jt. Tempo',
      cell: ({ getValue }: any) => (
        isValidDateString(getValue()) ? dayjs(getValue()).format('DD MMMM YYYY') : '-'
      ),
    },
    {
      id: '4',
      accessorKey: 'total',
      header: 'Total Invoice',
      cell: ({ getValue }): any => (
        <div className="text-right">{convertNumberToCurrency(getValue() as number || 0)}</div>
      ),
    },
    {
      id: '5',
      accessorKey: 'total_paid',
      header: 'Total Bayar',
      cell: ({ getValue }) => (
        <div className="text-right">{convertNumberToCurrency(getValue() as number || 0)}</div>
      ),
    },
    {
      id: '6',
      accessorKey: 'outstanding_amount',
      header: 'Sisa Invoice',
      cell: ({ getValue }) => (
        <div className="text-right">{convertNumberToCurrency(getValue() as number || 0)}</div>
      ),
    },
    {
      id: '7',
      accessorKey: 'invoice_state',
      header: 'Status',
      cell: ({ getValue }) => (
        <span className="capitalize">{getValue() as string}</span>
      ),
    },

  ], []);

  return (
    <BaseList
      resource="invoices"
      title="Daftar Invoice"
      resourceFilter={{ statuses: ['partial_paid', 'paid', 'confirmed'] }}
      columns={columns as any}
      filter={{
        sections: [
          {
            layout: {
              direction: 'vertical',
              sections: [
                {
                  input: {
                    type: 'datepicker',
                    name: 'updated_time_utc_start',
                    label: 'Tanggal Awal',
                  },
                },
              ],
            },
          },
          {
            layout: {
              direction: 'vertical',
              sections: [
                {
                  input: {
                    type: 'datepicker',
                    name: 'updated_time_utc_end',
                    label: 'Tanggal Akhir',
                  },
                },
                {
                  input: {
                    type: 'textfield',
                    name: 'invoice_number',
                    label: 'No Invoice',
                  },
                },
              ],
            },
          },
        ],
      }}
    />
  );
};

export default Invoice;
